<script setup>
import DataTable from '@/components/general/DataTable.vue'
import { computed, onMounted } from 'vue'
import { useOrderStore } from '@/stores/orderStore'
import { storeToRefs } from 'pinia'
import { ROUTES } from '@/router/routeNames'
import { statusColors, columns, paymentStatusLabels, orderStatusLabels } from '@/constants'
import { nairaSymbol } from '@/constants'
import { useAuthStore } from '@/stores/authStore'
const orderStore = useOrderStore()
const { orders, isLoading, error, ordersPagination: pagination } = storeToRefs(orderStore)
const router = useRouter()
const authStore = useAuthStore()
const { user } = storeToRefs(authStore)
// Load orders on component mount
onMounted(() => {
  orderStore.fetchOrders(1) // Always start at page 1
})

// Handle page change events from DataTable
const handlePageChange = (page) => {
  orderStore.fetchOrders(page)
}

const handleRouteChange = (id) => {
  router.push({ name: ROUTES.DASHBOARD_ORDER, params: { id: id } })
}


</script>

<template>
  <div class="sm:py-20">
    <DataTable
      :items="orders"
      :columns="columns"
      :pagination="pagination"
      @page-change="handlePageChange"
      @route-change="handleRouteChange"
    >
      <template #business="{ item }">
        <div class="text-sm font-medium text-gray-900 dark:text-gray-200">
          {{ item?.business?.name || 'N/A' }}
        </div>
        <div class="text-sm text-gray-500 dark:text-gray-400">
          {{ item?.business?.address || 'N/A' }}
        </div>
      </template>

      <template #customer="{ item }">
        <div class="text-sm font-medium text-gray-900 dark:text-gray-200">
          {{ item?.customer?.name || 'N/A' }}
        </div>
      </template>

      <template v-if="user?.role === USER_ROLES.CUSTOMER || user?.role === USER_ROLES.ADMIN" #total="{ item }"> {{ nairaSymbol }}{{ Number(item?.total_amount || 0).toFixed() }} </template>
      <template v-if="user?.role === USER_ROLES.BUSINESS" #total="{ item }"> {{ nairaSymbol }}{{ Number(item?.subtotal - item?.business_service_fee).toFixed() }} </template>

      <template #order_status="{ item }">
        <span
          class="inline-flex px-2 text-xs font-semibold leading-5 rounded-full"
          :class="statusColors[item?.status || 'pending']"
        >
          {{ orderStatusLabels[item?.status || 'pending'] }}
        </span>
      </template>

      <template #payment_status="{ item }">
        <span
          class="inline-flex px-2 text-xs font-semibold leading-5 rounded-full"
          :class="statusColors[item?.payment_status || 'pending']"
        >
          {{ paymentStatusLabels[item?.payment_status || 'pending'] }}
        </span>
      </template>

      <template #date="{ item }">
        {{ item?.created_at ? new Date(item.created_at).toLocaleDateString() : 'N/A' }}
      </template>

      <!-- <template #actions="{ item }">
        <button
          v-if="item?.status === 'pending'"
          @click="updateStatus(item?.id, 'processing')"
          class="mr-3 text-indigo-600 hover:text-indigo-900"
        >
          Process
        </button>
        <button
          v-if="item?.status === 'processing'"
          @click="updateStatus(item?.id, 'completed')"
          class="text-green-600 hover:text-green-900"
        >
          Complete
        </button>
      </template> -->
    </DataTable>
  </div>
</template>
